import { Pipe, inject, isDevMode, type PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { ArtifactService } from '../services/artifact.service';

@Pipe({
  name: 'artifact',
  standalone: true,
})
export class ArtifactPipe implements PipeTransform {
  #artifactService = inject(ArtifactService);

  transform(value: string, ...args: unknown[]) {
    if (!value) return of('');
      if (isDevMode()) {
        return this.#artifactService.getBase64Media(`/web/Image/get?fileName=${value}`)
      }
      return  this.#artifactService.getBase64Media(`/web/Image/get?fileName=${value}`);
  }
}
